// Protocol Buffers for Evidence Marketplace Services
// 
// Package: guardianai.v1.marketplace

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/marketplace/evidence.proto (package guardianai.v1.marketplace, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/marketplace/evidence.proto.
 */
export const file_guardianai_v1_marketplace_evidence: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.marketplace.GigResponse
 */
export type GigResponse = Message<"guardianai.v1.marketplace.GigResponse"> & {
  /**
   * @generated from field: string gig_id = 1;
   */
  gigId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string category = 4;
   */
  category: string;

  /**
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: int64 budget_cents = 6;
   */
  budgetCents: bigint;

  /**
   * @generated from field: string currency = 7;
   */
  currency: string;

  /**
   * @generated from field: string client_id = 8;
   */
  clientId: string;

  /**
   * @generated from field: int64 created_at = 9;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 deadline = 10;
   */
  deadline: bigint;

  /**
   * @generated from field: repeated string required_skills = 11;
   */
  requiredSkills: string[];

  /**
   * @generated from field: string location = 12;
   */
  location: string;

  /**
   * @generated from field: bool is_anonymous = 13;
   */
  isAnonymous: boolean;
};

/**
 * @generated from message guardianai.v1.marketplace.GigResponse
 */
export type GigResponseJson = {
  /**
   * @generated from field: string gig_id = 1;
   */
  gigId?: string;

  /**
   * @generated from field: string title = 2;
   */
  title?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: string category = 4;
   */
  category?: string;

  /**
   * @generated from field: string status = 5;
   */
  status?: string;

  /**
   * @generated from field: int64 budget_cents = 6;
   */
  budgetCents?: string;

  /**
   * @generated from field: string currency = 7;
   */
  currency?: string;

  /**
   * @generated from field: string client_id = 8;
   */
  clientId?: string;

  /**
   * @generated from field: int64 created_at = 9;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 deadline = 10;
   */
  deadline?: string;

  /**
   * @generated from field: repeated string required_skills = 11;
   */
  requiredSkills?: string[];

  /**
   * @generated from field: string location = 12;
   */
  location?: string;

  /**
   * @generated from field: bool is_anonymous = 13;
   */
  isAnonymous?: boolean;
};

/**
 * Describes the message guardianai.v1.marketplace.GigResponse.
 * Use `create(GigResponseSchema)` to create a new message.
 */
export const GigResponseSchema: GenMessage<GigResponse, {jsonType: GigResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 0);

/**
 * @generated from message guardianai.v1.marketplace.CreateGigRequest
 */
export type CreateGigRequest = Message<"guardianai.v1.marketplace.CreateGigRequest"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string category = 3;
   */
  category: string;

  /**
   * @generated from field: int64 budget_cents = 4;
   */
  budgetCents: bigint;

  /**
   * @generated from field: string currency = 5;
   */
  currency: string;

  /**
   * @generated from field: string client_id = 6;
   */
  clientId: string;

  /**
   * @generated from field: int64 deadline = 7;
   */
  deadline: bigint;

  /**
   * @generated from field: repeated string required_skills = 8;
   */
  requiredSkills: string[];

  /**
   * @generated from field: string location = 9;
   */
  location: string;

  /**
   * @generated from field: bool is_anonymous = 10;
   */
  isAnonymous: boolean;
};

/**
 * @generated from message guardianai.v1.marketplace.CreateGigRequest
 */
export type CreateGigRequestJson = {
  /**
   * @generated from field: string title = 1;
   */
  title?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: string category = 3;
   */
  category?: string;

  /**
   * @generated from field: int64 budget_cents = 4;
   */
  budgetCents?: string;

  /**
   * @generated from field: string currency = 5;
   */
  currency?: string;

  /**
   * @generated from field: string client_id = 6;
   */
  clientId?: string;

  /**
   * @generated from field: int64 deadline = 7;
   */
  deadline?: string;

  /**
   * @generated from field: repeated string required_skills = 8;
   */
  requiredSkills?: string[];

  /**
   * @generated from field: string location = 9;
   */
  location?: string;

  /**
   * @generated from field: bool is_anonymous = 10;
   */
  isAnonymous?: boolean;
};

/**
 * Describes the message guardianai.v1.marketplace.CreateGigRequest.
 * Use `create(CreateGigRequestSchema)` to create a new message.
 */
export const CreateGigRequestSchema: GenMessage<CreateGigRequest, {jsonType: CreateGigRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 1);

/**
 * @generated from message guardianai.v1.marketplace.GetGigRequest
 */
export type GetGigRequest = Message<"guardianai.v1.marketplace.GetGigRequest"> & {
  /**
   * @generated from field: string gig_id = 1;
   */
  gigId: string;
};

/**
 * @generated from message guardianai.v1.marketplace.GetGigRequest
 */
export type GetGigRequestJson = {
  /**
   * @generated from field: string gig_id = 1;
   */
  gigId?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.GetGigRequest.
 * Use `create(GetGigRequestSchema)` to create a new message.
 */
export const GetGigRequestSchema: GenMessage<GetGigRequest, {jsonType: GetGigRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 2);

/**
 * @generated from message guardianai.v1.marketplace.UpdateGigRequest
 */
export type UpdateGigRequest = Message<"guardianai.v1.marketplace.UpdateGigRequest"> & {
  /**
   * @generated from field: string gig_id = 1;
   */
  gigId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: int64 deadline = 5;
   */
  deadline: bigint;
};

/**
 * @generated from message guardianai.v1.marketplace.UpdateGigRequest
 */
export type UpdateGigRequestJson = {
  /**
   * @generated from field: string gig_id = 1;
   */
  gigId?: string;

  /**
   * @generated from field: string title = 2;
   */
  title?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: string status = 4;
   */
  status?: string;

  /**
   * @generated from field: int64 deadline = 5;
   */
  deadline?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.UpdateGigRequest.
 * Use `create(UpdateGigRequestSchema)` to create a new message.
 */
export const UpdateGigRequestSchema: GenMessage<UpdateGigRequest, {jsonType: UpdateGigRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 3);

/**
 * @generated from message guardianai.v1.marketplace.ListGigsRequest
 */
export type ListGigsRequest = Message<"guardianai.v1.marketplace.ListGigsRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string status_filter = 3;
   */
  statusFilter: string;

  /**
   * @generated from field: string category_filter = 4;
   */
  categoryFilter: string;

  /**
   * @generated from field: string client_id = 5;
   */
  clientId: string;
};

/**
 * @generated from message guardianai.v1.marketplace.ListGigsRequest
 */
export type ListGigsRequestJson = {
  /**
   * @generated from field: int32 page = 1;
   */
  page?: number;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize?: number;

  /**
   * @generated from field: string status_filter = 3;
   */
  statusFilter?: string;

  /**
   * @generated from field: string category_filter = 4;
   */
  categoryFilter?: string;

  /**
   * @generated from field: string client_id = 5;
   */
  clientId?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.ListGigsRequest.
 * Use `create(ListGigsRequestSchema)` to create a new message.
 */
export const ListGigsRequestSchema: GenMessage<ListGigsRequest, {jsonType: ListGigsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 4);

/**
 * @generated from message guardianai.v1.marketplace.ListGigsResponse
 */
export type ListGigsResponse = Message<"guardianai.v1.marketplace.ListGigsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.marketplace.GigResponse gigs = 1;
   */
  gigs: GigResponse[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.marketplace.ListGigsResponse
 */
export type ListGigsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.marketplace.GigResponse gigs = 1;
   */
  gigs?: GigResponseJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.marketplace.ListGigsResponse.
 * Use `create(ListGigsResponseSchema)` to create a new message.
 */
export const ListGigsResponseSchema: GenMessage<ListGigsResponse, {jsonType: ListGigsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 5);

/**
 * @generated from message guardianai.v1.marketplace.SearchGigsRequest
 */
export type SearchGigsRequest = Message<"guardianai.v1.marketplace.SearchGigsRequest"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: string category = 2;
   */
  category: string;

  /**
   * @generated from field: string location = 3;
   */
  location: string;

  /**
   * @generated from field: int64 min_budget = 4;
   */
  minBudget: bigint;

  /**
   * @generated from field: int64 max_budget = 5;
   */
  maxBudget: bigint;

  /**
   * @generated from field: int32 page = 6;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 7;
   */
  pageSize: number;
};

/**
 * @generated from message guardianai.v1.marketplace.SearchGigsRequest
 */
export type SearchGigsRequestJson = {
  /**
   * @generated from field: string query = 1;
   */
  query?: string;

  /**
   * @generated from field: string category = 2;
   */
  category?: string;

  /**
   * @generated from field: string location = 3;
   */
  location?: string;

  /**
   * @generated from field: int64 min_budget = 4;
   */
  minBudget?: string;

  /**
   * @generated from field: int64 max_budget = 5;
   */
  maxBudget?: string;

  /**
   * @generated from field: int32 page = 6;
   */
  page?: number;

  /**
   * @generated from field: int32 page_size = 7;
   */
  pageSize?: number;
};

/**
 * Describes the message guardianai.v1.marketplace.SearchGigsRequest.
 * Use `create(SearchGigsRequestSchema)` to create a new message.
 */
export const SearchGigsRequestSchema: GenMessage<SearchGigsRequest, {jsonType: SearchGigsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 6);

/**
 * @generated from message guardianai.v1.marketplace.ApplicationResponse
 */
export type ApplicationResponse = Message<"guardianai.v1.marketplace.ApplicationResponse"> & {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId: string;

  /**
   * @generated from field: string gig_id = 2;
   */
  gigId: string;

  /**
   * @generated from field: string applicant_id = 3;
   */
  applicantId: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: string proposal = 5;
   */
  proposal: string;

  /**
   * @generated from field: int64 proposed_amount = 6;
   */
  proposedAmount: bigint;

  /**
   * @generated from field: int64 created_at = 7;
   */
  createdAt: bigint;
};

/**
 * @generated from message guardianai.v1.marketplace.ApplicationResponse
 */
export type ApplicationResponseJson = {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId?: string;

  /**
   * @generated from field: string gig_id = 2;
   */
  gigId?: string;

  /**
   * @generated from field: string applicant_id = 3;
   */
  applicantId?: string;

  /**
   * @generated from field: string status = 4;
   */
  status?: string;

  /**
   * @generated from field: string proposal = 5;
   */
  proposal?: string;

  /**
   * @generated from field: int64 proposed_amount = 6;
   */
  proposedAmount?: string;

  /**
   * @generated from field: int64 created_at = 7;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.ApplicationResponse.
 * Use `create(ApplicationResponseSchema)` to create a new message.
 */
export const ApplicationResponseSchema: GenMessage<ApplicationResponse, {jsonType: ApplicationResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 7);

/**
 * @generated from message guardianai.v1.marketplace.ApplyForGigRequest
 */
export type ApplyForGigRequest = Message<"guardianai.v1.marketplace.ApplyForGigRequest"> & {
  /**
   * @generated from field: string gig_id = 1;
   */
  gigId: string;

  /**
   * @generated from field: string applicant_id = 2;
   */
  applicantId: string;

  /**
   * @generated from field: string proposal = 3;
   */
  proposal: string;

  /**
   * @generated from field: int64 proposed_amount = 4;
   */
  proposedAmount: bigint;
};

/**
 * @generated from message guardianai.v1.marketplace.ApplyForGigRequest
 */
export type ApplyForGigRequestJson = {
  /**
   * @generated from field: string gig_id = 1;
   */
  gigId?: string;

  /**
   * @generated from field: string applicant_id = 2;
   */
  applicantId?: string;

  /**
   * @generated from field: string proposal = 3;
   */
  proposal?: string;

  /**
   * @generated from field: int64 proposed_amount = 4;
   */
  proposedAmount?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.ApplyForGigRequest.
 * Use `create(ApplyForGigRequestSchema)` to create a new message.
 */
export const ApplyForGigRequestSchema: GenMessage<ApplyForGigRequest, {jsonType: ApplyForGigRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 8);

/**
 * @generated from message guardianai.v1.marketplace.GetApplicationsRequest
 */
export type GetApplicationsRequest = Message<"guardianai.v1.marketplace.GetApplicationsRequest"> & {
  /**
   * @generated from field: string gig_id = 1;
   */
  gigId: string;
};

/**
 * @generated from message guardianai.v1.marketplace.GetApplicationsRequest
 */
export type GetApplicationsRequestJson = {
  /**
   * @generated from field: string gig_id = 1;
   */
  gigId?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.GetApplicationsRequest.
 * Use `create(GetApplicationsRequestSchema)` to create a new message.
 */
export const GetApplicationsRequestSchema: GenMessage<GetApplicationsRequest, {jsonType: GetApplicationsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 9);

/**
 * @generated from message guardianai.v1.marketplace.ListApplicationsResponse
 */
export type ListApplicationsResponse = Message<"guardianai.v1.marketplace.ListApplicationsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.marketplace.ApplicationResponse applications = 1;
   */
  applications: ApplicationResponse[];
};

/**
 * @generated from message guardianai.v1.marketplace.ListApplicationsResponse
 */
export type ListApplicationsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.marketplace.ApplicationResponse applications = 1;
   */
  applications?: ApplicationResponseJson[];
};

/**
 * Describes the message guardianai.v1.marketplace.ListApplicationsResponse.
 * Use `create(ListApplicationsResponseSchema)` to create a new message.
 */
export const ListApplicationsResponseSchema: GenMessage<ListApplicationsResponse, {jsonType: ListApplicationsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 10);

/**
 * @generated from message guardianai.v1.marketplace.AcceptApplicationRequest
 */
export type AcceptApplicationRequest = Message<"guardianai.v1.marketplace.AcceptApplicationRequest"> & {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId: string;

  /**
   * @generated from field: string accepted_by = 2;
   */
  acceptedBy: string;
};

/**
 * @generated from message guardianai.v1.marketplace.AcceptApplicationRequest
 */
export type AcceptApplicationRequestJson = {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId?: string;

  /**
   * @generated from field: string accepted_by = 2;
   */
  acceptedBy?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.AcceptApplicationRequest.
 * Use `create(AcceptApplicationRequestSchema)` to create a new message.
 */
export const AcceptApplicationRequestSchema: GenMessage<AcceptApplicationRequest, {jsonType: AcceptApplicationRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 11);

/**
 * @generated from message guardianai.v1.marketplace.RejectApplicationRequest
 */
export type RejectApplicationRequest = Message<"guardianai.v1.marketplace.RejectApplicationRequest"> & {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId: string;

  /**
   * @generated from field: string rejected_by = 2;
   */
  rejectedBy: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.marketplace.RejectApplicationRequest
 */
export type RejectApplicationRequestJson = {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId?: string;

  /**
   * @generated from field: string rejected_by = 2;
   */
  rejectedBy?: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.RejectApplicationRequest.
 * Use `create(RejectApplicationRequestSchema)` to create a new message.
 */
export const RejectApplicationRequestSchema: GenMessage<RejectApplicationRequest, {jsonType: RejectApplicationRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 12);

/**
 * @generated from message guardianai.v1.marketplace.MarketplaceEvidenceResponse
 */
export type MarketplaceEvidenceResponse = Message<"guardianai.v1.marketplace.MarketplaceEvidenceResponse"> & {
  /**
   * @generated from field: string evidence_id = 1;
   */
  evidenceId: string;

  /**
   * @generated from field: string gig_id = 2;
   */
  gigId: string;

  /**
   * @generated from field: string submitter_id = 3;
   */
  submitterId: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: string title = 5;
   */
  title: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: repeated string file_urls = 7;
   */
  fileUrls: string[];

  /**
   * @generated from field: int64 submitted_at = 8;
   */
  submittedAt: bigint;

  /**
   * @generated from field: int64 reviewed_at = 9;
   */
  reviewedAt: bigint;

  /**
   * @generated from field: string reviewer_id = 10;
   */
  reviewerId: string;

  /**
   * @generated from field: string review_notes = 11;
   */
  reviewNotes: string;
};

/**
 * @generated from message guardianai.v1.marketplace.MarketplaceEvidenceResponse
 */
export type MarketplaceEvidenceResponseJson = {
  /**
   * @generated from field: string evidence_id = 1;
   */
  evidenceId?: string;

  /**
   * @generated from field: string gig_id = 2;
   */
  gigId?: string;

  /**
   * @generated from field: string submitter_id = 3;
   */
  submitterId?: string;

  /**
   * @generated from field: string status = 4;
   */
  status?: string;

  /**
   * @generated from field: string title = 5;
   */
  title?: string;

  /**
   * @generated from field: string description = 6;
   */
  description?: string;

  /**
   * @generated from field: repeated string file_urls = 7;
   */
  fileUrls?: string[];

  /**
   * @generated from field: int64 submitted_at = 8;
   */
  submittedAt?: string;

  /**
   * @generated from field: int64 reviewed_at = 9;
   */
  reviewedAt?: string;

  /**
   * @generated from field: string reviewer_id = 10;
   */
  reviewerId?: string;

  /**
   * @generated from field: string review_notes = 11;
   */
  reviewNotes?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.MarketplaceEvidenceResponse.
 * Use `create(MarketplaceEvidenceResponseSchema)` to create a new message.
 */
export const MarketplaceEvidenceResponseSchema: GenMessage<MarketplaceEvidenceResponse, {jsonType: MarketplaceEvidenceResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 13);

/**
 * @generated from message guardianai.v1.marketplace.SubmitEvidenceRequest
 */
export type SubmitEvidenceRequest = Message<"guardianai.v1.marketplace.SubmitEvidenceRequest"> & {
  /**
   * @generated from field: string gig_id = 1;
   */
  gigId: string;

  /**
   * @generated from field: string submitter_id = 2;
   */
  submitterId: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: repeated string file_urls = 5;
   */
  fileUrls: string[];
};

/**
 * @generated from message guardianai.v1.marketplace.SubmitEvidenceRequest
 */
export type SubmitEvidenceRequestJson = {
  /**
   * @generated from field: string gig_id = 1;
   */
  gigId?: string;

  /**
   * @generated from field: string submitter_id = 2;
   */
  submitterId?: string;

  /**
   * @generated from field: string title = 3;
   */
  title?: string;

  /**
   * @generated from field: string description = 4;
   */
  description?: string;

  /**
   * @generated from field: repeated string file_urls = 5;
   */
  fileUrls?: string[];
};

/**
 * Describes the message guardianai.v1.marketplace.SubmitEvidenceRequest.
 * Use `create(SubmitEvidenceRequestSchema)` to create a new message.
 */
export const SubmitEvidenceRequestSchema: GenMessage<SubmitEvidenceRequest, {jsonType: SubmitEvidenceRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 14);

/**
 * @generated from message guardianai.v1.marketplace.GetMarketplaceEvidenceRequest
 */
export type GetMarketplaceEvidenceRequest = Message<"guardianai.v1.marketplace.GetMarketplaceEvidenceRequest"> & {
  /**
   * @generated from field: string evidence_id = 1;
   */
  evidenceId: string;
};

/**
 * @generated from message guardianai.v1.marketplace.GetMarketplaceEvidenceRequest
 */
export type GetMarketplaceEvidenceRequestJson = {
  /**
   * @generated from field: string evidence_id = 1;
   */
  evidenceId?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.GetMarketplaceEvidenceRequest.
 * Use `create(GetMarketplaceEvidenceRequestSchema)` to create a new message.
 */
export const GetMarketplaceEvidenceRequestSchema: GenMessage<GetMarketplaceEvidenceRequest, {jsonType: GetMarketplaceEvidenceRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 15);

/**
 * @generated from message guardianai.v1.marketplace.ReviewEvidenceRequest
 */
export type ReviewEvidenceRequest = Message<"guardianai.v1.marketplace.ReviewEvidenceRequest"> & {
  /**
   * @generated from field: string evidence_id = 1;
   */
  evidenceId: string;

  /**
   * @generated from field: string reviewer_id = 2;
   */
  reviewerId: string;
};

/**
 * @generated from message guardianai.v1.marketplace.ReviewEvidenceRequest
 */
export type ReviewEvidenceRequestJson = {
  /**
   * @generated from field: string evidence_id = 1;
   */
  evidenceId?: string;

  /**
   * @generated from field: string reviewer_id = 2;
   */
  reviewerId?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.ReviewEvidenceRequest.
 * Use `create(ReviewEvidenceRequestSchema)` to create a new message.
 */
export const ReviewEvidenceRequestSchema: GenMessage<ReviewEvidenceRequest, {jsonType: ReviewEvidenceRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 16);

/**
 * @generated from message guardianai.v1.marketplace.ApproveEvidenceRequest
 */
export type ApproveEvidenceRequest = Message<"guardianai.v1.marketplace.ApproveEvidenceRequest"> & {
  /**
   * @generated from field: string evidence_id = 1;
   */
  evidenceId: string;

  /**
   * @generated from field: string approved_by = 2;
   */
  approvedBy: string;

  /**
   * @generated from field: string notes = 3;
   */
  notes: string;
};

/**
 * @generated from message guardianai.v1.marketplace.ApproveEvidenceRequest
 */
export type ApproveEvidenceRequestJson = {
  /**
   * @generated from field: string evidence_id = 1;
   */
  evidenceId?: string;

  /**
   * @generated from field: string approved_by = 2;
   */
  approvedBy?: string;

  /**
   * @generated from field: string notes = 3;
   */
  notes?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.ApproveEvidenceRequest.
 * Use `create(ApproveEvidenceRequestSchema)` to create a new message.
 */
export const ApproveEvidenceRequestSchema: GenMessage<ApproveEvidenceRequest, {jsonType: ApproveEvidenceRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 17);

/**
 * @generated from message guardianai.v1.marketplace.RejectEvidenceRequest
 */
export type RejectEvidenceRequest = Message<"guardianai.v1.marketplace.RejectEvidenceRequest"> & {
  /**
   * @generated from field: string evidence_id = 1;
   */
  evidenceId: string;

  /**
   * @generated from field: string rejected_by = 2;
   */
  rejectedBy: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.marketplace.RejectEvidenceRequest
 */
export type RejectEvidenceRequestJson = {
  /**
   * @generated from field: string evidence_id = 1;
   */
  evidenceId?: string;

  /**
   * @generated from field: string rejected_by = 2;
   */
  rejectedBy?: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.RejectEvidenceRequest.
 * Use `create(RejectEvidenceRequestSchema)` to create a new message.
 */
export const RejectEvidenceRequestSchema: GenMessage<RejectEvidenceRequest, {jsonType: RejectEvidenceRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 18);

/**
 * @generated from message guardianai.v1.marketplace.MarketplaceStatsRequest
 */
export type MarketplaceStatsRequest = Message<"guardianai.v1.marketplace.MarketplaceStatsRequest"> & {
  /**
   * @generated from field: string period = 1;
   */
  period: string;
};

/**
 * @generated from message guardianai.v1.marketplace.MarketplaceStatsRequest
 */
export type MarketplaceStatsRequestJson = {
  /**
   * @generated from field: string period = 1;
   */
  period?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.MarketplaceStatsRequest.
 * Use `create(MarketplaceStatsRequestSchema)` to create a new message.
 */
export const MarketplaceStatsRequestSchema: GenMessage<MarketplaceStatsRequest, {jsonType: MarketplaceStatsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 19);

/**
 * @generated from message guardianai.v1.marketplace.MarketplaceStatsResponse
 */
export type MarketplaceStatsResponse = Message<"guardianai.v1.marketplace.MarketplaceStatsResponse"> & {
  /**
   * @generated from field: int64 total_gigs = 1;
   */
  totalGigs: bigint;

  /**
   * @generated from field: int64 active_gigs = 2;
   */
  activeGigs: bigint;

  /**
   * @generated from field: int64 completed_gigs = 3;
   */
  completedGigs: bigint;

  /**
   * @generated from field: int64 total_evidence_submitted = 4;
   */
  totalEvidenceSubmitted: bigint;

  /**
   * @generated from field: double approval_rate = 5;
   */
  approvalRate: number;

  /**
   * @generated from field: double avg_completion_time_hours = 6;
   */
  avgCompletionTimeHours: number;

  /**
   * @generated from field: int64 total_value_traded = 7;
   */
  totalValueTraded: bigint;
};

/**
 * @generated from message guardianai.v1.marketplace.MarketplaceStatsResponse
 */
export type MarketplaceStatsResponseJson = {
  /**
   * @generated from field: int64 total_gigs = 1;
   */
  totalGigs?: string;

  /**
   * @generated from field: int64 active_gigs = 2;
   */
  activeGigs?: string;

  /**
   * @generated from field: int64 completed_gigs = 3;
   */
  completedGigs?: string;

  /**
   * @generated from field: int64 total_evidence_submitted = 4;
   */
  totalEvidenceSubmitted?: string;

  /**
   * @generated from field: double approval_rate = 5;
   */
  approvalRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double avg_completion_time_hours = 6;
   */
  avgCompletionTimeHours?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: int64 total_value_traded = 7;
   */
  totalValueTraded?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.MarketplaceStatsResponse.
 * Use `create(MarketplaceStatsResponseSchema)` to create a new message.
 */
export const MarketplaceStatsResponseSchema: GenMessage<MarketplaceStatsResponse, {jsonType: MarketplaceStatsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 20);

/**
 * @generated from message guardianai.v1.marketplace.AnonymousOrderResponse
 */
export type AnonymousOrderResponse = Message<"guardianai.v1.marketplace.AnonymousOrderResponse"> & {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId: string;

  /**
   * @generated from field: string anonymous_id = 2;
   */
  anonymousId: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: int64 budget_cents = 6;
   */
  budgetCents: bigint;

  /**
   * @generated from field: string currency = 7;
   */
  currency: string;

  /**
   * @generated from field: int64 created_at = 8;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 deadline = 9;
   */
  deadline: bigint;

  /**
   * @generated from field: string access_token = 10;
   */
  accessToken: string;

  /**
   * Extended fields for rich order management
   *
   * @generated from field: int64 updated_at = 11;
   */
  updatedAt: bigint;

  /**
   * @generated from field: string assigned_scout_id = 12;
   */
  assignedScoutId: string;

  /**
   * @generated from field: string evidence_type = 13;
   */
  evidenceType: string;

  /**
   * @generated from field: int64 budget_min = 14;
   */
  budgetMin: bigint;

  /**
   * @generated from field: int64 budget_max = 15;
   */
  budgetMax: bigint;

  /**
   * LOW, MEDIUM, HIGH, URGENT
   *
   * @generated from field: string urgency_level = 16;
   */
  urgencyLevel: string;

  /**
   * @generated from field: string special_instructions = 17;
   */
  specialInstructions: string;

  /**
   * @generated from field: repeated guardianai.v1.marketplace.OrderDeliverable deliverables = 18;
   */
  deliverables: OrderDeliverable[];

  /**
   * @generated from field: repeated guardianai.v1.marketplace.OrderCommunication communications = 19;
   */
  communications: OrderCommunication[];

  /**
   * @generated from field: repeated string required_skills = 20;
   */
  requiredSkills: string[];
};

/**
 * @generated from message guardianai.v1.marketplace.AnonymousOrderResponse
 */
export type AnonymousOrderResponseJson = {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId?: string;

  /**
   * @generated from field: string anonymous_id = 2;
   */
  anonymousId?: string;

  /**
   * @generated from field: string title = 3;
   */
  title?: string;

  /**
   * @generated from field: string description = 4;
   */
  description?: string;

  /**
   * @generated from field: string status = 5;
   */
  status?: string;

  /**
   * @generated from field: int64 budget_cents = 6;
   */
  budgetCents?: string;

  /**
   * @generated from field: string currency = 7;
   */
  currency?: string;

  /**
   * @generated from field: int64 created_at = 8;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 deadline = 9;
   */
  deadline?: string;

  /**
   * @generated from field: string access_token = 10;
   */
  accessToken?: string;

  /**
   * Extended fields for rich order management
   *
   * @generated from field: int64 updated_at = 11;
   */
  updatedAt?: string;

  /**
   * @generated from field: string assigned_scout_id = 12;
   */
  assignedScoutId?: string;

  /**
   * @generated from field: string evidence_type = 13;
   */
  evidenceType?: string;

  /**
   * @generated from field: int64 budget_min = 14;
   */
  budgetMin?: string;

  /**
   * @generated from field: int64 budget_max = 15;
   */
  budgetMax?: string;

  /**
   * LOW, MEDIUM, HIGH, URGENT
   *
   * @generated from field: string urgency_level = 16;
   */
  urgencyLevel?: string;

  /**
   * @generated from field: string special_instructions = 17;
   */
  specialInstructions?: string;

  /**
   * @generated from field: repeated guardianai.v1.marketplace.OrderDeliverable deliverables = 18;
   */
  deliverables?: OrderDeliverableJson[];

  /**
   * @generated from field: repeated guardianai.v1.marketplace.OrderCommunication communications = 19;
   */
  communications?: OrderCommunicationJson[];

  /**
   * @generated from field: repeated string required_skills = 20;
   */
  requiredSkills?: string[];
};

/**
 * Describes the message guardianai.v1.marketplace.AnonymousOrderResponse.
 * Use `create(AnonymousOrderResponseSchema)` to create a new message.
 */
export const AnonymousOrderResponseSchema: GenMessage<AnonymousOrderResponse, {jsonType: AnonymousOrderResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 21);

/**
 * @generated from message guardianai.v1.marketplace.OrderDeliverable
 */
export type OrderDeliverable = Message<"guardianai.v1.marketplace.OrderDeliverable"> & {
  /**
   * @generated from field: string deliverable_id = 1;
   */
  deliverableId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string file_url = 4;
   */
  fileUrl: string;

  /**
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: int64 submitted_at = 6;
   */
  submittedAt: bigint;

  /**
   * Multiple file attachments
   *
   * @generated from field: repeated string file_urls = 7;
   */
  fileUrls: string[];

  /**
   * Feedback from customer on deliverable
   *
   * @generated from field: string customer_feedback = 8;
   */
  customerFeedback: string;
};

/**
 * @generated from message guardianai.v1.marketplace.OrderDeliverable
 */
export type OrderDeliverableJson = {
  /**
   * @generated from field: string deliverable_id = 1;
   */
  deliverableId?: string;

  /**
   * @generated from field: string name = 2;
   */
  name?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: string file_url = 4;
   */
  fileUrl?: string;

  /**
   * @generated from field: string status = 5;
   */
  status?: string;

  /**
   * @generated from field: int64 submitted_at = 6;
   */
  submittedAt?: string;

  /**
   * Multiple file attachments
   *
   * @generated from field: repeated string file_urls = 7;
   */
  fileUrls?: string[];

  /**
   * Feedback from customer on deliverable
   *
   * @generated from field: string customer_feedback = 8;
   */
  customerFeedback?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.OrderDeliverable.
 * Use `create(OrderDeliverableSchema)` to create a new message.
 */
export const OrderDeliverableSchema: GenMessage<OrderDeliverable, {jsonType: OrderDeliverableJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 22);

/**
 * @generated from message guardianai.v1.marketplace.OrderCommunication
 */
export type OrderCommunication = Message<"guardianai.v1.marketplace.OrderCommunication"> & {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: string sender_id = 2;
   */
  senderId: string;

  /**
   * @generated from field: string sender_role = 3;
   */
  senderRole: string;

  /**
   * @generated from field: string content = 4;
   */
  content: string;

  /**
   * @generated from field: int64 created_at = 5;
   */
  createdAt: bigint;

  /**
   * @generated from field: bool is_read = 6;
   */
  isRead: boolean;

  /**
   * CUSTOMER, SCOUT, SYSTEM
   *
   * @generated from field: string sender_type = 7;
   */
  senderType: string;
};

/**
 * @generated from message guardianai.v1.marketplace.OrderCommunication
 */
export type OrderCommunicationJson = {
  /**
   * @generated from field: string message_id = 1;
   */
  messageId?: string;

  /**
   * @generated from field: string sender_id = 2;
   */
  senderId?: string;

  /**
   * @generated from field: string sender_role = 3;
   */
  senderRole?: string;

  /**
   * @generated from field: string content = 4;
   */
  content?: string;

  /**
   * @generated from field: int64 created_at = 5;
   */
  createdAt?: string;

  /**
   * @generated from field: bool is_read = 6;
   */
  isRead?: boolean;

  /**
   * CUSTOMER, SCOUT, SYSTEM
   *
   * @generated from field: string sender_type = 7;
   */
  senderType?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.OrderCommunication.
 * Use `create(OrderCommunicationSchema)` to create a new message.
 */
export const OrderCommunicationSchema: GenMessage<OrderCommunication, {jsonType: OrderCommunicationJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 23);

/**
 * @generated from message guardianai.v1.marketplace.CreateAnonymousOrderRequest
 */
export type CreateAnonymousOrderRequest = Message<"guardianai.v1.marketplace.CreateAnonymousOrderRequest"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: int64 budget_cents = 3;
   */
  budgetCents: bigint;

  /**
   * @generated from field: string currency = 4;
   */
  currency: string;

  /**
   * @generated from field: int64 deadline = 5;
   */
  deadline: bigint;

  /**
   * @generated from field: string contact_method = 6;
   */
  contactMethod: string;

  /**
   * Extended fields for rich order creation
   *
   * @generated from field: string evidence_type = 7;
   */
  evidenceType: string;

  /**
   * @generated from field: int64 budget_min = 8;
   */
  budgetMin: bigint;

  /**
   * @generated from field: int64 budget_max = 9;
   */
  budgetMax: bigint;

  /**
   * LOW, MEDIUM, HIGH, URGENT
   *
   * @generated from field: string urgency_level = 10;
   */
  urgencyLevel: string;

  /**
   * @generated from field: string special_instructions = 11;
   */
  specialInstructions: string;

  /**
   * @generated from field: repeated string required_skills = 12;
   */
  requiredSkills: string[];

  /**
   * Link to original trust score scan
   *
   * @generated from field: string trust_score_scan_id = 13;
   */
  trustScoreScanId: string;

  /**
   * Anonymous identifier for the customer
   *
   * @generated from field: string anonymous_customer_id = 14;
   */
  anonymousCustomerId: string;
};

/**
 * @generated from message guardianai.v1.marketplace.CreateAnonymousOrderRequest
 */
export type CreateAnonymousOrderRequestJson = {
  /**
   * @generated from field: string title = 1;
   */
  title?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: int64 budget_cents = 3;
   */
  budgetCents?: string;

  /**
   * @generated from field: string currency = 4;
   */
  currency?: string;

  /**
   * @generated from field: int64 deadline = 5;
   */
  deadline?: string;

  /**
   * @generated from field: string contact_method = 6;
   */
  contactMethod?: string;

  /**
   * Extended fields for rich order creation
   *
   * @generated from field: string evidence_type = 7;
   */
  evidenceType?: string;

  /**
   * @generated from field: int64 budget_min = 8;
   */
  budgetMin?: string;

  /**
   * @generated from field: int64 budget_max = 9;
   */
  budgetMax?: string;

  /**
   * LOW, MEDIUM, HIGH, URGENT
   *
   * @generated from field: string urgency_level = 10;
   */
  urgencyLevel?: string;

  /**
   * @generated from field: string special_instructions = 11;
   */
  specialInstructions?: string;

  /**
   * @generated from field: repeated string required_skills = 12;
   */
  requiredSkills?: string[];

  /**
   * Link to original trust score scan
   *
   * @generated from field: string trust_score_scan_id = 13;
   */
  trustScoreScanId?: string;

  /**
   * Anonymous identifier for the customer
   *
   * @generated from field: string anonymous_customer_id = 14;
   */
  anonymousCustomerId?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.CreateAnonymousOrderRequest.
 * Use `create(CreateAnonymousOrderRequestSchema)` to create a new message.
 */
export const CreateAnonymousOrderRequestSchema: GenMessage<CreateAnonymousOrderRequest, {jsonType: CreateAnonymousOrderRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 24);

/**
 * @generated from message guardianai.v1.marketplace.GetAnonymousOrderRequest
 */
export type GetAnonymousOrderRequest = Message<"guardianai.v1.marketplace.GetAnonymousOrderRequest"> & {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId: string;

  /**
   * @generated from field: string access_token = 2;
   */
  accessToken: string;
};

/**
 * @generated from message guardianai.v1.marketplace.GetAnonymousOrderRequest
 */
export type GetAnonymousOrderRequestJson = {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId?: string;

  /**
   * @generated from field: string access_token = 2;
   */
  accessToken?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.GetAnonymousOrderRequest.
 * Use `create(GetAnonymousOrderRequestSchema)` to create a new message.
 */
export const GetAnonymousOrderRequestSchema: GenMessage<GetAnonymousOrderRequest, {jsonType: GetAnonymousOrderRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 25);

/**
 * @generated from message guardianai.v1.marketplace.UpdateOrderStatusRequest
 */
export type UpdateOrderStatusRequest = Message<"guardianai.v1.marketplace.UpdateOrderStatusRequest"> & {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: string updated_by = 3;
   */
  updatedBy: string;
};

/**
 * @generated from message guardianai.v1.marketplace.UpdateOrderStatusRequest
 */
export type UpdateOrderStatusRequestJson = {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId?: string;

  /**
   * @generated from field: string status = 2;
   */
  status?: string;

  /**
   * @generated from field: string updated_by = 3;
   */
  updatedBy?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.UpdateOrderStatusRequest.
 * Use `create(UpdateOrderStatusRequestSchema)` to create a new message.
 */
export const UpdateOrderStatusRequestSchema: GenMessage<UpdateOrderStatusRequest, {jsonType: UpdateOrderStatusRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 26);

/**
 * @generated from message guardianai.v1.marketplace.ListAnonymousOrdersRequest
 */
export type ListAnonymousOrdersRequest = Message<"guardianai.v1.marketplace.ListAnonymousOrdersRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string status_filter = 3;
   */
  statusFilter: string;
};

/**
 * @generated from message guardianai.v1.marketplace.ListAnonymousOrdersRequest
 */
export type ListAnonymousOrdersRequestJson = {
  /**
   * @generated from field: int32 page = 1;
   */
  page?: number;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize?: number;

  /**
   * @generated from field: string status_filter = 3;
   */
  statusFilter?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.ListAnonymousOrdersRequest.
 * Use `create(ListAnonymousOrdersRequestSchema)` to create a new message.
 */
export const ListAnonymousOrdersRequestSchema: GenMessage<ListAnonymousOrdersRequest, {jsonType: ListAnonymousOrdersRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 27);

/**
 * @generated from message guardianai.v1.marketplace.ListAnonymousOrdersResponse
 */
export type ListAnonymousOrdersResponse = Message<"guardianai.v1.marketplace.ListAnonymousOrdersResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.marketplace.AnonymousOrderResponse orders = 1;
   */
  orders: AnonymousOrderResponse[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.marketplace.ListAnonymousOrdersResponse
 */
export type ListAnonymousOrdersResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.marketplace.AnonymousOrderResponse orders = 1;
   */
  orders?: AnonymousOrderResponseJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.marketplace.ListAnonymousOrdersResponse.
 * Use `create(ListAnonymousOrdersResponseSchema)` to create a new message.
 */
export const ListAnonymousOrdersResponseSchema: GenMessage<ListAnonymousOrdersResponse, {jsonType: ListAnonymousOrdersResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 28);

/**
 * @generated from message guardianai.v1.marketplace.FulfillOrderRequest
 */
export type FulfillOrderRequest = Message<"guardianai.v1.marketplace.FulfillOrderRequest"> & {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId: string;

  /**
   * @generated from field: string fulfilled_by = 2;
   */
  fulfilledBy: string;

  /**
   * @generated from field: repeated string evidence_ids = 3;
   */
  evidenceIds: string[];
};

/**
 * @generated from message guardianai.v1.marketplace.FulfillOrderRequest
 */
export type FulfillOrderRequestJson = {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId?: string;

  /**
   * @generated from field: string fulfilled_by = 2;
   */
  fulfilledBy?: string;

  /**
   * @generated from field: repeated string evidence_ids = 3;
   */
  evidenceIds?: string[];
};

/**
 * Describes the message guardianai.v1.marketplace.FulfillOrderRequest.
 * Use `create(FulfillOrderRequestSchema)` to create a new message.
 */
export const FulfillOrderRequestSchema: GenMessage<FulfillOrderRequest, {jsonType: FulfillOrderRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 29);

/**
 * @generated from message guardianai.v1.marketplace.CancelOrderRequest
 */
export type CancelOrderRequest = Message<"guardianai.v1.marketplace.CancelOrderRequest"> & {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.marketplace.CancelOrderRequest
 */
export type CancelOrderRequestJson = {
  /**
   * @generated from field: string order_id = 1;
   */
  orderId?: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.marketplace.CancelOrderRequest.
 * Use `create(CancelOrderRequestSchema)` to create a new message.
 */
export const CancelOrderRequestSchema: GenMessage<CancelOrderRequest, {jsonType: CancelOrderRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_marketplace_evidence, 30);

/**
 * @generated from service guardianai.v1.marketplace.EvidenceMarketplaceService
 */
export const EvidenceMarketplaceService: GenService<{
  /**
   * Gig management
   *
   * @generated from rpc guardianai.v1.marketplace.EvidenceMarketplaceService.CreateGig
   */
  createGig: {
    methodKind: "unary";
    input: typeof CreateGigRequestSchema;
    output: typeof GigResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.marketplace.EvidenceMarketplaceService.GetGig
   */
  getGig: {
    methodKind: "unary";
    input: typeof GetGigRequestSchema;
    output: typeof GigResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.marketplace.EvidenceMarketplaceService.UpdateGig
   */
  updateGig: {
    methodKind: "unary";
    input: typeof UpdateGigRequestSchema;
    output: typeof GigResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.marketplace.EvidenceMarketplaceService.ListGigs
   */
  listGigs: {
    methodKind: "unary";
    input: typeof ListGigsRequestSchema;
    output: typeof ListGigsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.marketplace.EvidenceMarketplaceService.SearchGigs
   */
  searchGigs: {
    methodKind: "unary";
    input: typeof SearchGigsRequestSchema;
    output: typeof ListGigsResponseSchema;
  },
  /**
   * Gig applications
   *
   * @generated from rpc guardianai.v1.marketplace.EvidenceMarketplaceService.ApplyForGig
   */
  applyForGig: {
    methodKind: "unary";
    input: typeof ApplyForGigRequestSchema;
    output: typeof ApplicationResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.marketplace.EvidenceMarketplaceService.GetApplications
   */
  getApplications: {
    methodKind: "unary";
    input: typeof GetApplicationsRequestSchema;
    output: typeof ListApplicationsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.marketplace.EvidenceMarketplaceService.AcceptApplication
   */
  acceptApplication: {
    methodKind: "unary";
    input: typeof AcceptApplicationRequestSchema;
    output: typeof ApplicationResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.marketplace.EvidenceMarketplaceService.RejectApplication
   */
  rejectApplication: {
    methodKind: "unary";
    input: typeof RejectApplicationRequestSchema;
    output: typeof ApplicationResponseSchema;
  },
  /**
   * Evidence submission
   *
   * @generated from rpc guardianai.v1.marketplace.EvidenceMarketplaceService.SubmitEvidence
   */
  submitEvidence: {
    methodKind: "unary";
    input: typeof SubmitEvidenceRequestSchema;
    output: typeof MarketplaceEvidenceResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.marketplace.EvidenceMarketplaceService.GetEvidence
   */
  getEvidence: {
    methodKind: "unary";
    input: typeof GetMarketplaceEvidenceRequestSchema;
    output: typeof MarketplaceEvidenceResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.marketplace.EvidenceMarketplaceService.ReviewEvidence
   */
  reviewEvidence: {
    methodKind: "unary";
    input: typeof ReviewEvidenceRequestSchema;
    output: typeof MarketplaceEvidenceResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.marketplace.EvidenceMarketplaceService.ApproveEvidence
   */
  approveEvidence: {
    methodKind: "unary";
    input: typeof ApproveEvidenceRequestSchema;
    output: typeof MarketplaceEvidenceResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.marketplace.EvidenceMarketplaceService.RejectEvidence
   */
  rejectEvidence: {
    methodKind: "unary";
    input: typeof RejectEvidenceRequestSchema;
    output: typeof MarketplaceEvidenceResponseSchema;
  },
  /**
   * Marketplace stats
   *
   * @generated from rpc guardianai.v1.marketplace.EvidenceMarketplaceService.GetMarketplaceStats
   */
  getMarketplaceStats: {
    methodKind: "unary";
    input: typeof MarketplaceStatsRequestSchema;
    output: typeof MarketplaceStatsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_marketplace_evidence, 0);

/**
 * @generated from service guardianai.v1.marketplace.AnonymousOrderService
 */
export const AnonymousOrderService: GenService<{
  /**
   * @generated from rpc guardianai.v1.marketplace.AnonymousOrderService.CreateAnonymousOrder
   */
  createAnonymousOrder: {
    methodKind: "unary";
    input: typeof CreateAnonymousOrderRequestSchema;
    output: typeof AnonymousOrderResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.marketplace.AnonymousOrderService.GetAnonymousOrder
   */
  getAnonymousOrder: {
    methodKind: "unary";
    input: typeof GetAnonymousOrderRequestSchema;
    output: typeof AnonymousOrderResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.marketplace.AnonymousOrderService.UpdateOrderStatus
   */
  updateOrderStatus: {
    methodKind: "unary";
    input: typeof UpdateOrderStatusRequestSchema;
    output: typeof AnonymousOrderResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.marketplace.AnonymousOrderService.ListAnonymousOrders
   */
  listAnonymousOrders: {
    methodKind: "unary";
    input: typeof ListAnonymousOrdersRequestSchema;
    output: typeof ListAnonymousOrdersResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.marketplace.AnonymousOrderService.FulfillOrder
   */
  fulfillOrder: {
    methodKind: "unary";
    input: typeof FulfillOrderRequestSchema;
    output: typeof AnonymousOrderResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.marketplace.AnonymousOrderService.CancelOrder
   */
  cancelOrder: {
    methodKind: "unary";
    input: typeof CancelOrderRequestSchema;
    output: typeof AnonymousOrderResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_marketplace_evidence, 1);

